// ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import axios from 'axios';
import { API_URL } from '../config';
import './LandingPage.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email }); // ✅ only 2 args
      setSent(true);
    } catch (err) {
      console.error('Forgot error:', err?.response?.data || err.message);
      setError('Could not send reset link. If this persists, contact admin.');
    }
  };

  return (
    <div className="landing-wrapper">
      <PageTitle title="Forgot Password" noIndex canonical="https://markazsync.com/forgot-password" />
      <div className="form-panel forgot-password-panel">
        <div className="form-header">
          <div className="login-brand-logo-crop" aria-label="MarkazSync">
            <img className="login-brand-logo" src="/logo.png" alt="" aria-hidden="true" />
          </div>
          <div className="form-title">Reset Password</div>
        </div>
        {sent ? (
          <p className="forgot-password-copy">Check your email for a reset link, if an account exists.</p>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="email"
              placeholder="Your account email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
            {error && <div className="error-message">{error}</div>}
            <button className="reset-password-submit" type="submit">Send reset link</button>
          </form>
        )}
        <Link to="/login" className="forgot-password-back-btn">
          <i className="bi bi-arrow-left" aria-hidden="true" />
          Back to login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
